<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">商品类型价格参数</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品类型价格参数
      <small>商品类型价格参数...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品类型价格参数列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add_typepriceattr">
          <i class="fa fa-plus"></i> 新增价格参数
        </button>
        <button class="btn btn-theme btn-sm m-l-5" @click="$router.go(-1);">
          <i class="fa fa-arrow-left"></i> 返回
        </button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >修改</button>

          <Poptip
            transfer
            confirm
            title="是否要删除此价格参数?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer title="商品类型的价格属性参数" v-model="v_edit_type" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="参数名称" label-position="top" prop="name">
          <Input v-model="formData.name" placeholder="参数名称" />
        </FormItem>

        <FormItem label="排序" label-position="top">
          <InputNumber v-model="formData.sortval"></InputNumber>
        </FormItem>

        <FormItem label="备注" label-position="top">
          <Input
            type="textarea"
            v-model="formData.remarks"
            :rows="4"
            placeholder="please enter the description"
          />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_type = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import {
  storeTypePriceAttrData,
  getTypePriceAttrList,
  removeTypePriceAttrData
} from "@/api/goods";
export default {
  data() {
    return {
      columns: [
        {
          title: "参数名称",
          key: "name",
          width: 300
        },
        {
          title: "排序",
          key: "sortval",
          width: 120
        },
        {
          title: "备注",
          key: "remarks"
        },
        {
          title: "操作",
          slot: "action",
          width: 280,
          align: "left"
        }
      ],
      data: [],
      formData: {
        id: 0,
        typeid: 0,
        name: "",
        sortval: 0,
        remarks: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "名称必填",
            tirgger: "blur"
          }
        ]
      },
      v_edit_type: false,
      totalRows: 0,
      pageNum: 10,
      currentPage: 1,
      typedata: {}
    };
  },
  mounted() {
    let data = this.$route.params.data;

    if (typeof data == "undefined") {
      this.$Modal.info({
        title: "提示",
        content: "此页不支持刷新页面"
      });
      this.$router.go(-1);
      return;
    }
    this.typedata = data;
    let filterCond = {
      typeid: data.id,
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
  },
  methods: {
    fn_load_data(filterCond) {
      getTypePriceAttrList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_add_typepriceattr() {
      this.v_edit_type = true;
      this.formData = {
        id: 0,
        typeid: this.typedata.id,
        name: "",
        sortval: 0,
        remarks: ""
      };
    },
    fn_edit(row, index) {
      this.formData = row;
      this.v_edit_type = true;
    },

    fn_remove(row, index) {
      removeTypePriceAttrData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeTypePriceAttrData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.v_edit_type = false;
                this.data.push(res.data.data);
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    }
  }
};
</script>